module.exports = __webpack_public_path__ + "static/en-us-e78972b5c4732f5f47a990ae3f42fc0c.svg";